import { BACKEND_ROUTES } from "../../../backendRoutes";
import { useMemo } from "react";
import useSWR from "swr";

export const useMissionGeometries = (missionUuid) => {
    const { data, error, mutate } = useSWR(
        missionUuid
            ? `${BACKEND_ROUTES.MISSION_GEOMETRY}?missionUuid=${missionUuid}`
            : null
    );

    const geometries = useMemo(
        () => ({
            soil: data?.rows?.find((g) => g.type === "Soil") || null,
            radiometricTarget:
                data?.rows?.find((g) => g.type === "Radiometric target") ||
                null,
        }),
        [data]
    );

    return {
        geometries,
        isLoading: !error && !data,
        error,
        refetch: mutate,
    };
};
